<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/jkjy">健康教育</router-link> >
      {{ channelName }}
    </div>
    <div class="container-width">
      <LIST
        :listData="list"
        :articlePath="articlePath"
        :channelName="channelName"
      ></LIST>
      <Pagination
        :pageCount="totalPages"
        :total="total"
        @togglePage="togglePage($event)"
      ></Pagination>
    </div>
  </div>
</template>
<script>
import service from "../../service/jkjy";
import BANNER from "../../components/banner/jkjy";
export default {
  name: "QITA",
  data() {
    return {
      navigationData: [
        {
          name: "内科",
          path: "/jkjy",
          width: "20%",
        },
        {
          name: "外科",
          path: "/jkjy/waike",
          width: "20%",
        },
        {
          name: "妇产科",
          path: "/jkjy/fuchanke",
          width: "20%",
        },
        {
          name: "儿科",
          path: "/jkjy/erke",
          width: "20%",
        },
        {
          name: "感染科",
          path: "/jkjy/ganranke",
          width: "20%",
        },
        {
          name: "中医科",
          path: "/jkjy/zhongyike",
          width: "20%",
        },
        {
          name: "五官科",
          path: "/jkjy/wuguanke",
          width: "20%",
        },
        {
          name: "心理科",
          path: "/jkjy/xinlike",
          width: "20%",
        },
        {
          name: "医辅科室",
          path: "/jkjy/yifu",
          width: "20%",
        },
        {
          name: "其他科室",
          path: "/jkjy/qita",
          width: "20%",
        },
      ],
      currentPath: "/jkjy/qita",
      articlePath: "/jkjy/article",
      current: {},
      channel: {
        id: "",
      },
      channelName: "其他科室",
      list: [],
      pageIndex: 1,
      pageSize: window.screen.width < 720 ? 6 : 10,
      totalPages: 0,
      total: 0,
    };
  },
  components: { BANNER },
  computed: {},
  created() {
    this.init();
  },
  beforeMount() {},
  methods: {
    init() {
      service.getChannelList(
        {
          isshow: "1",
        },
        (res) => {
          this.channel = res.content.find((item) => {
            if (item.name == this.channelName) {
              return item.id;
            }
          });
          this.getChannelInfoList();
        }
      );
    },
    // 根据channelID 获取信息列表
    getChannelInfoList() {
      let parmes = {
        channelId: this.channel.id,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        isshow: "1",
      };
      service.getChannelInfoList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.releaseDate = item.releaseDate
              ? item.releaseDate.substr(0, 10)
              : "";
          });
        }
        this.list = res.content || [];
        this.totalPages = parseInt(res.totalPages) || 0;
        this.total = res.totalElements;
      });
    },
    goArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        this.$router.push({
          path: `/jkjy/qita/article`,
          query: {
            id: e.id,
            channelName: this.channelName,
          },
        });
      }
    },
    togglePage(indexPage) {
      this.pageIndex = indexPage;
      this.init();
    },
  },
  mounted() {},
  watch: {},
};
</script>

<style>
</style>
